import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, CalendarClock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function DemoDayDialog({ target, onClose, onDone }) {
  const [count, setCount] = useState(12);
  const [myPhone, setMyPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const open = !!target;

  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/admin/workshops/${target.workshop_id}/demo-day`, { count, my_phone: myPhone.trim() || null });
      const mine = r.data.my_job ? ` — your car is ${r.data.my_job.vehicle_reg} in bay ${r.data.my_job.bay_number}` : "";
      toast.success(`Demo day loaded — ${r.data.count} Toyota cars in ${target.workshop_name}${mine}`);
      onDone?.(); onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't load demo day");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && !busy && onClose()}>
      <DialogContent className="max-w-md" data-testid="demo-day-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><CalendarClock className="w-4 h-4 text-warning" /> Load a Toyota demo day</DialogTitle>
          <DialogDescription>
            Deletes <b>every job</b> in “{target?.workshop_name}” and replaces it with fake Toyota customers (dummy 07700 900xxx numbers, example.com emails — nothing can reach a real person).
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-1">
          <div>
            <div className="label-overline mb-1.5">How many cars</div>
            <div className="flex gap-2">
              {[12, 25].map((n) => (
                <button key={n} type="button" onClick={() => setCount(n)} data-testid={`demo-day-count-${n}`}
                  className={`px-3 py-1.5 rounded-md border text-sm font-bold transition-colors ${count === n ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>
                  {n} cars
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="label-overline mb-1.5 block" htmlFor="demo-day-my-phone">Put my mobile on one car (optional)</label>
            <input id="demo-day-my-phone" value={myPhone} onChange={(e) => setMyPhone(e.target.value)} placeholder="07885 735028" inputMode="tel"
              className="w-full h-10 px-3 rounded-md border border-border bg-background text-sm" data-testid="demo-day-my-phone" />
            <p className="text-xs text-muted-foreground mt-1.5">That car gets your number and a real red/amber quote, so texting or calling the ServiceSell number from your phone tests the AI assistant and receptionist as a customer.</p>
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} disabled={busy} className="px-3 py-2 rounded-md border border-border text-sm font-semibold" data-testid="demo-day-cancel">Cancel</button>
            <button type="button" onClick={run} disabled={busy} className="px-3 py-2 rounded-md bg-warning text-warning-foreground text-sm font-bold inline-flex items-center gap-2 disabled:opacity-50" data-testid="demo-day-confirm">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CalendarClock className="w-4 h-4" />} Wipe & load {count} cars
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
